export default __webpack_public_path__ + "fca742de1e52774d3fad8b707fc660be.ttf";